module.exports = __webpack_public_path__ + "static/media/lianxi.75f902a4.png";